import runWaterForm from "./waterForm/main.js";
import runIngestForm from "./ingestForm/main.js";

runWaterForm();
runIngestForm();
